import { createContext, useContext } from "react";

export const JsxParserComponentsContext: React.Context<Record<string, any>> = createContext({});
export const useJsxParserComponents: () => Record<string, any> = () => useContext(JsxParserComponentsContext);